<template>
    <div class="doc-section">
        <h1>
            Alta de dispositivos
        </h1>
        <p>
            Para agregar un nuevo dispositivo, hacer clic en el botón “Agregar dispositivo”, con lo cual se abrirá el
            formulario
        </p>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            En el formulario se tienen que llenar los campos que son obligatorios y seleccionar que tipo de dispositivo
            es <strong>“Comercial”</strong> o <strong>“Institucional”</strong>, sin embargo, hay un campo que por
            default se encuentra desactivado pese a que es un campo obligatorio, esto es porque, como se indica en su
            descripción, es un dato que depende del modelo, por lo que unicamente se activará después de seleccionar el
            modelo.
        </p>
        <div class="info-card">
            <p>
                <strong>Nota: </strong>
                Por ejemplo, al seleccionar el modelo <strong>TK108</strong>, el encabezado del campo cambiará su
                descripción a <strong>IMEI*</strong>, y pedirá ingresar el IMEI del dispositivo a 15 dígitos; en cambio,
                si se elige el modelo <strong>TKSTAR</strong>, el encabezado del campo cambiará su descripción a
                <strong>ID*</strong>, y pedirá ingresar el Id del dispositivo a 10 dígitos.
            </p>
        </div>




        <h3>Referencia Visual</h3>
         <div v-if="plataforma === 'web'" class="platform-content">
             <CarruselAciqui :items="imagenes" />
         </div>
         <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesMoviles" />
         </div>

        <h2>Guardar Dispositivo</h2>
        <ol class="ul-contenedor step-list">
            <li>Botón “Guardar y continuar”. Valida los datos que se ingresaron en el formulario y, de ser correctos,
                guarda el registro del nuevo dispositivo. Automáticamente, se limpiarán los datos del formulario para
                que se pueda continuar agregando nuevos dispositivos.</li>
            <li>Botón “Cancelar”. Cierra el formulario de registro y nos devuelve a la vista Dispositivos sin guardar
                los cambios realizados.</li>
            <li>Botón “Guardar dispositivo”. Valida los datos que se ingresaron en el formulario y, de ser correctos,
                guarda el registro del nuevo dispositivo. Cierra el formulario de registro y nos devuelve a la vista
                Dispositivos en donde se podrá apreciar el dispositivo agregado.</li>
        </ol>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesGuardado" />
        </div>
        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesGuardadoMoviles" />
        </div>
    </div>
</template>


<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'AltaDispositivo',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenes: [
            {
                nombre: "Formulario alta dispositivo",
                url: "img/Dispositivos/formularioAltaDispositivo.png",
                descripcion: ""
            },
            {
                nombre: "Selección modelo GPS",
                url: "img/Dispositivos/seleccionModelo.png",
                descripcion: "Seleccionando el modelo TK108, el campo bloqueado se activa y su encabezado cambia a IMEI*"
            },
            {
                nombre: "Validación IME",
                url: "img/Dispositivos/validacionIMEI.png",
                descripcion: "la validación del campo se adecua a los 15 dígitos requeridos para el IMEI, como se muestra en la siguiente imagen"
            },
            {
                nombre: "Validación ID",
                url: "img/Dispositivos/validacionID.png",
                descripcion: "En cambio, seleccionando el modelo TKSTAR, de igual forma se activa el campo bloqueado pero su encabezado cambia a ID*, la validación del campo se adecua a los 10 dígitos requeridos para el Id, como se muestra en la siguiente imagen"
            },

        ],

        imagenesGuardado: [
            {
                nombre: "Guardar Dispositivo",
                url: "img/Dispositivos/botonesGuardado.png",
                descripcion: ""
            },
        ],


        imagenesMoviles: [
            {
                nombre: "Formulario alta dispositivo",
                url: "img/Dispositivos/moviles/formularioAltaDispositivo.png",
                descripcion: ""
            },
            {
                nombre: "Selección modelo GPS",
                url: "img/Dispositivos/moviles/seleccionModelo.png",
                descripcion: "Seleccionando el modelo TK108, el campo bloqueado se activa y su encabezado cambia a IMEI*"
            },
            {
                nombre: "Validación IME",
                url: "img/Dispositivos/moviles/validacionIMEI.png",
                descripcion: "la validación del campo se adecua a los 15 dígitos requeridos para el IMEI, como se muestra en la siguiente imagen"
            },
            {
                nombre: "Validación ID",
                url: "img/Dispositivos/moviles/validacionID.png",
                descripcion: "En cambio, seleccionando el modelo TKSTAR, de igual forma se activa el campo bloqueado pero su encabezado cambia a ID*, la validación del campo se adecua a los 10 dígitos requeridos para el Id, como se muestra en la siguiente imagen"
            },

        ],

        imagenesGuardadoMoviles: [
            {
                nombre: "Guardar Dispositivo",
                url: "img/Dispositivos/moviles/botonesGuardado.png",
                descripcion: ""
            },
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>